import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ApiService } from '../../Services/apiServices';
import { showToast } from '../../Utlis/toastUtlis';

const AuthModal = ({ show, handleClose }) => {

    const [registerPage, setRegisterPage] = useState(false);
    const [forgotPasswordPage, setForgotPasswordPage] = useState(false);
    const [regformData, setRegFormData] = useState({
        full_name: '',
        email: '',
        mobile: '',
        password: '',
    });

    const [loginformData, setLoginFormData] = useState({
        email: '',
        password: '',
    })

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    // useEffect(() => {
    //     const savedUserData = JSON.parse(localStorage.getItem("USER_DATA"));
    //     const rememberMe = localStorage.getItem("REMEMBER_ME") === "true";
    
    //     // Check if "Remember Me" and saved user data exist
    //     if (savedUserData && rememberMe) {
    //         setLoginFormData((prevState) => ({
    //             ...prevState,
    //             email: savedUserData.email || "", // Autofill email if available
    //         }));
    
    //         // Set the "Remember Me" checkbox checked state based on localStorage
    //         const rememberMeCheckbox = document.getElementById("remember-me");
    //         if (rememberMeCheckbox) {
    //             rememberMeCheckbox.checked = true;
    //         }
    //     }
    // }, []);  // Run once on component mount
    


    if (!show) return null;

    const handleregChange = (e) => {
        setRegFormData({
            ...regformData,
            [e.target.name]: e.target.value,
        });
    };

    const handleloginChange = (e) => {
        setLoginFormData({
            ...loginformData,
            [e.target.name]: e.target.value,
        });
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (!regformData.full_name) {
            showToast("error", "Please Enter Full Name")
            setLoading(false);
            return false
        }

        if (!regformData.email) {
            showToast("error", "Please Enter Email")
            setLoading(false);
            return false
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(regformData.email)) {
            showToast("error", "Please enter a valid email address");
            setLoading(false);
            return false;
        }


        if (!regformData.mobile) {
            showToast("error", "Please Enter Mobile")
            setLoading(false);
            return false
        }

        const mobileRegex = /^[6-9]\d{9}$/;

        if (!mobileRegex.test(regformData.mobile)) {
            showToast("error", "Please enter a valid mobile number");
            setLoading(false);
            return false;
        }

        if (!regformData.password) {
            showToast("error", "Please Enter Password")
            setLoading(false);
            return false
        }



        try {
            const registerData = await ApiService.Commanpostrequest("register", regformData);
            if (registerData.success) {
                showToast("success", "Registration Successfull!")
                setRegFormData({
                    full_name: '',
                    email: '',
                    mobile: '',
                    password: '',
                });
                window.location.reload();
            } else {

                showToast("error", "Registration failed. Please try again.");
            }

        } catch (error) {
            console.error("Registration error: ", error)
            if (error.response && error.response.data.errors) {
                const errors = error.response.data.errors;
                if (errors.email) {
                    showToast("error", "This email is already registered");

                }
            } else {
                showToast("error", "An Error Occured . Please try again.");

            }
        } finally {
            setLoading(false);
        }

    }


    

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (!loginformData.email) {
            showToast("error", "Please Enter Email")
            setLoading(false);
            return false
        }

        if (!loginformData.password) {
            showToast("error", "Please Enter Password")
            setLoading(false);
            return false
        }

        try {


            const loginData = await ApiService.Commanpostrequest("login", loginformData);

            if (loginData.user) {
                const userData = {
                    id: loginData.user.id,
                    email: loginData.user.email,
                    username: loginData.user.full_name,
                    mobile:loginData.user.mobile
                };

                localStorage.setItem("USER_DATA", JSON.stringify(userData));

                // const rememberMeChecked = document.getElementById("remember-me").checked;
                // if (rememberMeChecked) {
                //     localStorage.setItem("REMEMBER_ME", "true");
                // } else {
                //     localStorage.removeItem("REMEMBER_ME");
                // }

                showToast("success", "Login Successfully!");
                window.location.reload();
            } else {
                showToast("error", loginData.message);
                setLoginFormData({ email: '', password: '' });
            }
        } catch (error) {
            console.error("Login error: ", error);
            if (error.response) {
                console.log("Error Response:", error.response);
            }

            if (error.response && error.response.status === 401) {
                showToast("error", "Invalid credentials. Please try again.");
            } else {
                showToast("error", "An error occurred. Please try again later.");
            }
        } finally {
            setLoading(false);
        }

    }



  


    return (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ background: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                        </h5>
                        <button type="button" className="close btn-danger" onClick={handleClose}>
                            <span>&times;</span>
                        </button>
                    </div>

                    {/* Login Form */}
                    {!registerPage && !forgotPasswordPage && (
                        <>
                            <div className="text-center">
                                <p className="mt-3" style={{ fontSize: 20, fontWeight: 600 }}>
                                    Sign in with <span style={{ color: "#FEA116" }}>WeJai</span>
                                </p>
                                <span style={{ fontSize: 12, color: 'gray' }}>
                                    For Better Experience, Booking &amp; Regular updates
                                </span>
                            </div>

                            <div className="modal-body">
                                <form onSubmit={handleLogin}>
                                    <div className="form-group mb-3">
                                        <input type="email" className="form-control"
                                            name='email'
                                            placeholder="Email Address"
                                            onChange={handleloginChange}
                                            value={loginformData.email}
                                        />
                                    </div>
                                    <div className="form-group mb-3">
                                        <input type="password" className="form-control"
                                            name='password'
                                            onChange={handleloginChange}
                                            value={loginformData.password}
                                            placeholder="Password" />
                                    </div>
                                    {/* <div className="col-8 mb-2">
                                        <div className="icheck-primary">
                                            <input type="checkbox" id="remember-me" />
                                            <label htmlFor="remember-me" style={{ fontWeight: 500, marginLeft: "10px" }}>
                                                Remember Me
                                            </label>
                                        </div>
                                    </div> */}
                                    <div className="d-grid mb-4">
                                        <button type="submit" className="btn btn-primary btn01 btn1 btn-primary1 mt-2" disabled={loading}>
                                            {loading ? "Loading..." : "Login"}
                                        </button>
                                    </div>
                                </form>

                                <div className="text-center">
                                    <a style={{ textDecoration: "none", fontSize: "16px", fontWeight: "600" }} href="javascript:;" onClick={() => setForgotPasswordPage(true)}>Forgot Password?</a>
                                </div>
                                <p className="text-center mt-2">
                                    Don't have an account? <a style={{ textDecoration: "none", fontSize: "16px", fontWeight: "600" }} href="javascript:;" onClick={() => setRegisterPage(true)}>Sign Up</a>
                                </p>
                            </div>
                        </>
                    )}

                    {/* Signup Form */}
                    {registerPage && (
                        <>
                            <div>
                                <div className="text-center">
                                    <p className="mt-3" style={{ fontSize: 20, fontWeight: 600 }}>
                                        Sign Up with <span style={{ color: "#FEA116" }}>WeJai</span>
                                    </p>
                                    <span style={{ fontSize: 12, color: 'gray' }}>
                                        For Better Experience, Booking &amp; Regular updates
                                    </span>
                                </div>
                                <div className="modal-body">
                                    <form onSubmit={handleRegister}>
                                        <div className="form-group mb-3">
                                            <input type="text" name="full_name" className="form-control"
                                                placeholder="Full Name"
                                                onChange={handleregChange}
                                                value={regformData.full_name}
                                            />
                                        </div>
                                        <div className="form-group mb-3">
                                            <input type="email" name="email" className="form-control"
                                                placeholder="Email Address"
                                                onChange={handleregChange}
                                                value={regformData.email}
                                            />
                                        </div>
                                        <div className="form-group country-input mb-3">
                                            <input type="number" name="mobile" className="form-control"
                                                placeholder="Mobile Number"
                                                onChange={handleregChange}
                                                value={regformData.mobile}
                                            />
                                        </div>
                                        <div className="form-group mb-3">
                                            <input type="password" name="password" className="form-control"
                                                placeholder="Password"
                                                onChange={handleregChange}
                                                value={regformData.password}
                                            />
                                        </div>
                                        <div className="d-grid mb-4">
                                            <button type="submit" className="btn-primary btn01 btn1 btn-primary1" disabled={loading}>
                                                {loading ? 'Loading...' : ' Register'}
                                            </button>
                                        </div>
                                    </form>
                                    <p style={{ fontSize: "12px" }} className="text-center tx-color-03">By continuing I agree with the <Link style={{ textDecoration: "none", fontSize: "12px", fontWeight: "600" }} to="/privacy-policy" className="tx-theme">Privacy Policy</Link> and <Link style={{ textDecoration: "none", fontSize: "12px", fontWeight: "600" }} to="/term-conditions" className="tx-theme">Terms
                                        &amp; Conditions</Link></p>
                                    <p className="text-center">Already have an account? <a style={{ textDecoration: "none", fontSize: "16px", fontWeight: "600" }} href="javascript:;" onClick={() => setRegisterPage(false)} className="tx-theme">Sign In</a></p>
                                </div>
                            </div>

                        </>
                    )}

                    {/* Forgot Password Form */}
                    {forgotPasswordPage && (
                        <>
                            <div className="modal-body">
                                <div className="text-center mb-3"><img src="/img/forgot.png" alt="img" style={{ width: "150px" }} />
                                    <h5 className="tx-theme">Forgot Password </h5>
                                    <p className="tx-color-02">Please Enter your registerd email Id</p>
                                </div>
                                <p className="forgot-success" />
                                <form>
                                    <div className="form-group mb-3">
                                        <input type="email" className="form-control loginRequired" id="user-email" name="email" placeholder="Email Address" />
                                        <p className="forgot-email" />
                                    </div>
                                    <div className="d-grid mb-4">
                                        <button type="submit" className="btn-primary btn01 btn1 btn-primary1">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                                <p className="text-center">Already have an account? <a style={{ textDecoration: "none", fontSize: "16px", fontWeight: "600" }} href="javascript:;" onClick={() => setForgotPasswordPage(false)} className="tx-theme">Sign In</a></p>
                            </div>

                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AuthModal;
